module.exports = __webpack_public_path__ + "static/media/dairy.0253c9f2.png";